import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ProductGallery = () => {
  const [selectedImage, setSelectedImage] = useState(0);

  const productImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/ry9g7xa5_Gemini_Generated_Image_k5gzztk5gzztk5gz.png',
      title: 'Black Rubber Bush',
      description: 'Two Black Rubber Bushes showcasing durability'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/j535ejmu_Gemini_Generated_Image_uqblw2uqblw2uqbl.png',
      title: 'Premium PU Bush',
      description: 'Single PU Bush featuring premium orange lining'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/uwx09ueh_Gemini_Generated_Image_snhk5csnhk5csnhk.png',
      title: 'Black Rubber Bush',
      description: 'Professional grade rubber bush with black interior coating'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/e0vjte0q_Gemini_Generated_Image_4grzti4grzti4grz.png',
      title: 'PU Bush',
      description: 'Stacked view showing vibrant PU Bush orange-red interior lining'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/2p46im8z_Gemini_Generated_Image_uokno0uokno0uokn.png',
      title: 'Complete Product Range',
      description: 'Various sizes of Camel Rubber Bush products'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/5jvalemy_Gemini_Generated_Image_qjik2mqjik2mqjik.png',
      title: 'Internal Structure Detail',
      description: 'Close-up showing grooved interior design for optimal grip'
    }
  ];

  const nextImage = () => {
    setSelectedImage((prev) => (prev + 1) % productImages.length);
  };

  const prevImage = () => {
    setSelectedImage((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Product <span className="text-amber-700">Gallery</span>
            </h2>
            <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Explore our premium Camel Rubber Bush products in stunning desert settings
            </p>
          </div>

          {/* Main Image Display */}
          <div className="relative mb-8">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-b from-amber-50 to-orange-50">
              <img 
                src={productImages[selectedImage].url}
                alt={productImages[selectedImage].title}
                className="w-full h-[500px] md:h-[600px] object-contain"
              />
              
              {/* Navigation Arrows */}
              <button
                onClick={prevImage}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition-all hover:scale-110"
              >
                <ChevronLeft className="text-amber-700" size={28} />
              </button>
              <button
                onClick={nextImage}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition-all hover:scale-110"
              >
                <ChevronRight className="text-amber-700" size={28} />
              </button>

              {/* Image Info Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-2">
                  {productImages[selectedImage].title}
                </h3>
                <p className="text-amber-200">
                  {productImages[selectedImage].description}
                </p>
              </div>

              {/* Image Counter */}
              <div className="absolute top-4 right-4 bg-black/70 backdrop-blur-sm px-4 py-2 rounded-full">
                <span className="text-white font-semibold">
                  {selectedImage + 1} / {productImages.length}
                </span>
              </div>
            </div>
          </div>

          {/* Thumbnail Grid */}
          <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
            {productImages.map((image, index) => (
              <button
                key={index}
                onClick={() => setSelectedImage(index)}
                className={`relative rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:scale-105 ${
                  selectedImage === index 
                    ? 'ring-4 ring-amber-600 scale-105' 
                    : 'opacity-70 hover:opacity-100'
                }`}
              >
                <img 
                  src={image.url}
                  alt={image.title}
                  className="w-full h-24 object-cover"
                />
                {selectedImage === index && (
                  <div className="absolute inset-0 bg-amber-600/20"></div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductGallery;
